import { render } from "./MainMenu.vue?vue&type=template&id=7cb4af4f"
import script from "./MainMenu.vue?vue&type=script&lang=js"
export * from "./MainMenu.vue?vue&type=script&lang=js"

import "./MainMenu.vue?vue&type=style&index=0&id=7cb4af4f&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__